var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_ClaimTransactionPropertyGroup_form_newTitle"),
      widthClass: "max-1000",
      pad: "0",
      initData: _vm.claimTransactionGroupData,
      checkData: [
        "claim_transaction_type_property_group_name",
        "claim_transaction_type_property_group_description",
        "claim_transaction_type_property_group_code",
        "remarks",
      ],
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Stepper", {
              attrs: { curStep: _vm.curStep, items: _vm.stepper },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      maxlength: "100",
                                      bindData:
                                        _vm.claimTransactionGroupData
                                          .claim_transaction_type_property_group_name,
                                      label: _vm.$t(
                                        "label_essweb_ClaimTransactionPropertyGroup_form_groupNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.claimTransactionGroupData.claim_transaction_type_property_group_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData:
                                        _vm.claimTransactionGroupData
                                          .claim_transaction_type_property_group_description,
                                      maxlength: "500",
                                      label: _vm.$t(
                                        "label_essweb_ClaimTransactionPropertyGroup_form_descriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.claimTransactionGroupData.claim_transaction_type_property_group_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      maxlength: "100",
                                      label: _vm.$t(
                                        "label_essweb_ClaimTransactionPropertyGroup_form_codeLabel"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.claimTransactionGroupData
                                          .claim_transaction_type_property_group_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.claimTransactionGroupData,
                                          "claim_transaction_type_property_group_code",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "\n                  claimTransactionGroupData.claim_transaction_type_property_group_code\n                ",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_ClaimTransactionPropertyGroup_form_remarkLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-textarea", {
                                    attrs: {
                                      rows: "5",
                                      "no-resize": "",
                                      maxlength: "500",
                                      dense: "",
                                      counter: "500",
                                      filled: "",
                                      "single-line": "",
                                      name: "input-7-4",
                                    },
                                    model: {
                                      value:
                                        _vm.claimTransactionGroupData.remarks,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.claimTransactionGroupData,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "claimTransactionGroupData.remarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c("PropertyList", {
                        attrs: {
                          items: _vm.desserts,
                          listdata: _vm.PropertyListData,
                        },
                        on: { edit: _vm.toEditProperty },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: {
                newBtn:
                  _vm.stepper.length == _vm.curStep && _vm.curStep != 0
                    ? true
                    : false,
                step: _vm.stepper.length == _vm.curStep ? false : true,
                preStep: _vm.curStep > 1 ? true : false,
              },
              on: {
                next: _vm.toNext,
                pre: function ($event) {
                  _vm.curStep = _vm.curStep - 1
                },
                new: _vm.toNew,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("MappingPopup5", {
              attrs: {
                show: _vm.showMappingPopup,
                PropertyData: _vm.PropertyData,
              },
              on: {
                close: function ($event) {
                  _vm.showMappingPopup = false
                  _vm.PropertyData = null
                },
                confirm: _vm.onEditProperty,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }